import * as actions from "../actionTypes"

const initialState = {
    value: false,
}

export default function configMenu(state = initialState, action) {
    switch (action.type) {
        case actions.SET_CONFIG_MENU_OPEN: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
